import React, { Component } from 'react';
import '../../styles/style.css'
import { Grid, Row, Col } from 'react-bootstrap'
import { Field, reduxForm } from 'redux-form'
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { connect } from 'react-redux'



const styles = {
  spacetop: {
      height: '20px'
  },
}
class HousingClosed extends Component {

  render() {
    return (
      <div>
        <div className="subheader">
          <h4>Housing Assignments In Progress</h4>
        </div>
        <Grid>
          <Row>
            <Col xs={12} md={8} mdOffset={2}>
                <div style={styles.spacetop}></div>
                <p>Hi Rhodes! Final housing assignments are being made.
                  You will be able to review assignments in just a few hours!
                  If you were unable to submit preferences before the deadline,
                  check back at 8am tomorrow!
                </p>
            </Col>
          </Row>
        </Grid>
      </div>
    )
  }
}


//=====================================
//  CONNECT
//-------------------------------------

export default connect()(HousingClosed)


// WEBPACK FOOTER //
// ./src/views/pages/housing-closed/index.js